module.exports = __webpack_public_path__ + "static/media/btn_parrot_active.cfb16fee.png";